import { collection, doc, getDocs, query, setDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';

const OwnerTrn = () => {
  const [ownerTrn, setOwnerTrn] = useState('');

  const [trnFromDB, setTrnFromDB] = useState('');
  const [openTrnField, setOpenTrnField] = useState(true);

  const [dataTrigger, setDataTrigger] = useState(false);
  const [ownerTrnError, setOwnerTrnError] = useState('');

  const [loading, setLoading] = useState(true);

  //?fecth TRN of owner from db
  useEffect(() => {
    setLoading(true);
    const q = query(collection(db, 'owner'));
    getDocs(q)
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          const docRaw = doc.data();
          console.log('Owner trn from db', docRaw);
          setTrnFromDB(docRaw.trn);
          setOwnerTrn(docRaw.trn);
          setOpenTrnField(false);
        });
      })
      .catch((error) => {
        setOpenTrnField(true);
        console.error('Error getting documents:', error);
      });
    setLoading(false);
  }, [dataTrigger]);

  const saveTRNtoDB = async () => {
    setOwnerTrnError('');
    if (!ownerTrn) {
      setOwnerTrnError('Fill this field');
      return;
    }
    setOwnerTrnError('');
    const itemsToSend = {
      trn: ownerTrn,
    };
    try {
      await setDoc(doc(db, 'owner', 'duplicate'), itemsToSend);
      setOpenTrnField(false);
      // alert('TRN saved to db');
      setDataTrigger((ov) => !ov);
    } catch (e) {
      console.log('fb up err', e);
      alert('Something went wrong, while saving');
    }
  };
  console.log(openTrnField);
  return (
    <div className="flex items-baseline">
      TRN :
      {loading ? (
        'Loading'
      ) : (
        <>
          {!openTrnField && (
            <>
              <span className="ml-1 ">{trnFromDB}</span>
              <button
                className="underline font-bold ml-3 print:hidden  flex-shrink-0"
                onClick={() => setOpenTrnField(true)}
              >
                Edit
              </button>
            </>
          )}
          {openTrnField && (
            <>
              <div>
                <input
                  type="number"
                  value={ownerTrn}
                  onKeyDown={(event) => {
                    if (
                      event.key === 'e' ||
                      event.key === 'E' ||
                      event.key === '-'
                    ) {
                      event.preventDefault();
                    }
                  }}
                  onChange={(e) => setOwnerTrn(e.target.value)}
                  className="border  border-gray-300 pl-1 py-2 print:hidden ml-1"
                  placeholder="Enter TRN"
                />
                {ownerTrnError && (
                  <p className="ml-1 text-xs text-red-600 animate__animated animate__fadeIn">
                    {ownerTrnError}
                  </p>
                )}
              </div>
              <button
                className="px-3 py-1 bg-lime-500 print:hidden ml-1 flex-shrink-0"
                onClick={() => saveTRNtoDB()}
              >
                Save
              </button>
              {trnFromDB && (
                <button
                  className="underline font-bold ml-1 print:hidden  flex-shrink-0"
                  onClick={() => setOpenTrnField(false)}
                >
                  Cancel
                </button>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default OwnerTrn;
